import { Form } from '@/components/forms';
import { EmailInput } from '@/components/forms/email-input/component';
import { PasswordInput } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { FormikProps } from 'formik';
import * as yup from 'yup';
import styles from './form.module.css';
export type LoginFormValues = {
	email: string;
	password: string;
};

const validationSchema = yup.object({
	email: yup.string().required('Please enter your email.').email('The email is badly formatted.'),
	password: yup.string().required('Password is required'),
});

type FormProps = {
	onSubmit: (values: LoginFormValues) => void;
	formRef: React.RefObject<FormikProps<LoginFormValues>>;
};

export const LoginForm = ({ formRef, onSubmit }: FormProps) => {
	const initialValues: LoginFormValues = {
		email: '',
		password: '',
	};

	return (
		<>
			<Form
				initialValues={initialValues}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				innerRef={formRef}
			>
				{({ getFieldProps, errors, touched }) => (
					<>
						<EmailInput
							label="Email Address"
							placeholder="Enter your email address"
							{...getFieldProps('email')}
							error={touched.email && errors.email}
							mb="md"
						/>
						<PasswordInput
							label="Password"
							placeholder="******"
							{...getFieldProps('password')}
							error={touched.password && errors.password}
							mb="md"
						/>
					</>
				)}
			</Form>
			<Link className={styles.link} to="/request-password-reset">
				Forgot your password?
			</Link>
		</>
	);
};
